<template>
  <div
    v-if="active"
    class="click-blocker"
    :style="blockerStyle"
    @click.stop.prevent
    @touchstart.stop.prevent
    @touchend.stop.prevent
    @mousedown.stop.prevent
    @mouseup.stop.prevent
  />
</template>

<script>
  export default {
    props: {
      value: {
        type: Boolean,
        required: true,
      },
      zIndex: {
        type: Number,
        default: 99999,
      },
      timeout: {
        type: Number,
        default: null,
      },
      transparent: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      active: false,
      timer: null,
    }),

    watch: {
      value: {
        immediate: true,
        handler (newValue) {
          if (newValue) {
            this.activate()
          } else {
            this.deactivate()
          }
        },
      },
    },

    beforeDestroy () {
      this.clearTimer()
    },

    methods: {
      activate () {
        this.active = true
        if (this.timeout !== null) {
          this.clearTimer()
          this.timer = setTimeout(() => {
            this.deactivate()
          }, this.timeout)
        }
      },
      deactivate () {
        this.active = false
        this.clearTimer()
        this.$emit('input', false)
      },
      clearTimer () {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
      },
    },

    computed: {
      blockerStyle () {
        return {
          zIndex: this.zIndex,
          backgroundColor: this.transparent ? 'transparent' : 'rgba(0, 0, 0, 0.3)',
        }
      },
    },
  }
</script>

<style scoped>
  .click-blocker {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: not-allowed;
  }
</style>

